export const QuestionsDialogFormInputsStyles = {
  question: 'text-16px font-normal text-gray150',
  answerInput: 'mt-5'
} 
